import {integrityContent} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadIntegrityContent(selection: any) {
  return useLoad(integrityContent, 'iD_Content', {values: selection});
}

export default useLoadIntegrityContent;
